export default "__VITE_ASSET__CEQQR$wZ__"